var React = require('react');

var TeamCompareHeader = React.createClass({
    render : function(){
        var classNames = ["teamCompareHeaderWrap", this.props.bordered || '', this.props.noTeams || ''];

        var sHome = this.props.home.abbreviation.toUpperCase();
        var sAway = this.props.away.abbreviation.toUpperCase();

        return (
            <div className={classNames.join(' ')}>
                <div className="teamCompareHeader">
                <div className="team team1">
                    <img className="imageLoaded" src={this.props.home.logo}/>
                    <span className="record">{sHome}</span>
                </div>
                <div className="header">{this.props.heading}</div>
                <div className="team team2">
                    <span className="record">{sAway}</span>
                    <img className="imageLoaded" src={this.props.away.logo}/>
                </div>
                </div>
            </div>
        );
    }
});

module.exports = TeamCompareHeader;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TeamCompareHeader.jsx
 **/